import { FeatureToggleClientService } from 'feature-toggle-client';
const blipInsightsVisibility = 'blip-insights-visibility';
export class BlipInsightsFeatures {
    static async isBlipInsightsEnabled() {
        return await FeatureToggleClientService.getInstance().isUserFeatureEnabled(blipInsightsVisibility);
    }
}
